import { customElement, property, query } from 'lit/decorators.js';
import { GzSingleSelectWebComponent } from '../../gzSingleSelectDropdown';
import { GzSingleSelectController } from '../controller/GzSingleSelectController';
import { DEFAULT_DATA_LIMIT, GetItemsResponse } from '../types';
import { GzSingleSelectListWebComponent } from '../../gzSingleSelectList';
import { DropdownMenuEvents } from '../../gzDropdownMenu/types';

@customElement('gz-single-select-complex')
export class GzSingleSelectComplexWebComponent extends GzSingleSelectWebComponent {
  public controller: GzSingleSelectController;

  hasDynamicSearch = true;

  @property({ type: String, attribute: false, reflect: true })
  apiType = '';

  @property({ type: Number, attribute: false, reflect: true })
  pageLimit = DEFAULT_DATA_LIMIT;

  @query('#single-selection-list')
  public readonly selectList!: GzSingleSelectListWebComponent;

  setApiType(apiType: string) {
    if (apiType === '' || this.apiType) {
      return;
    }

    this.apiType = apiType;
    this.buildController(this.apiType);
  }

  private buildController(apiType) {
    const dependencies = {
      api: {
        type: apiType,
      },
    };
    this.controller = new GzSingleSelectController(dependencies, this);
  }

  private ensureController() {
    if (this.controller || !this.apiType) {
      return;
    }
    this.buildController(this.apiType);
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.updateComplete.then(() => this.ensureController());
  }

  public async setFilterOptions(
    itemsInfo: GetItemsResponse | undefined,
    preventBackendCall = false,
    extraDetails: any = null
  ): Promise<void> {
    this.ensureController();

    if (extraDetails) {
      this.controller.extraDetailsForRequest = extraDetails;
    }

    await this.controller.setFilterOptions(itemsInfo, preventBackendCall);
  }

  public resetSelectorDropdown() {
    this.dropdownMenu.dispatchEvent(new CustomEvent(DropdownMenuEvents.CLEAR));
    this.filterOptions = [];
  }

  public getSelectedOption() {
    return this.selectList.selectedOption;
  }
}
